import { ReactNode } from 'react';
import Header from '../Header/Header';

type Props = {
  children?: ReactNode;
};
const Layout = ({ children }: Props): JSX.Element => {

  return (
    <>
      <Header />
      {children}
    </>
  );
};

export default Layout;
